// MUI
import { Grid, Typography } from "@mui/material";

// Components
import OemDataSections from "@DataPages/components/OEM/Tables/OemDataTable/OemDataSections";
import OemDataHeaderIcon from "@DataPages/components/OEM/Tables/OemDataTable/OemDataHeaderIcon";

// Types
import { IOEMPageContent } from "@DataPages/types/oem/model";
import { FilterRankingDataPageProps, RowArray } from "@DataPages/components/OEM/OEMTabBody";

type OemDataPageProps = Readonly<{
	tableProps?: object;
	data: IOEMPageContent;
	franchiseName: string;
	parentsProps: object;
	onUpdateCellTableValue: (dataToUpdate: unknown, successUpdateCallback: Function, errorUpdateCallback: Function) => Promise<void>;
	navigateButton: (direction: "left" | "right") => false | JSX.Element | null;
	isPaginationPage?: boolean;
	filterRankingDataPage?: ({ content, tableInformation }: Readonly<FilterRankingDataPageProps>) => RowArray;
	oemDataTab: string;
}>;
export default function OemDataPage(props: OemDataPageProps) {
	const parentsProps = { ...props.parentsProps, pageNumber: props?.data.pageNumber, parents: [] };

	return (
		<Grid container paddingX={1.5}>
			{(Boolean(props?.data.pageName) || Boolean(props?.data.pageInformation?.icon)) && (
				<Grid item xs={12} paddingX={4}>
					<Grid container direction="row" rowSpacing={2} justifyContent={"space-between"} alignItems={"center"}>
						<Typography className={"regular-montserrat-label"} sx={{ fontSize: "1.5rem" }}>
							{`${props.franchiseName} ${props?.data.pageName}`}
						</Typography>
						<OemDataHeaderIcon icon={props?.data.pageInformation?.icon} />
					</Grid>
				</Grid>
			)}
			<Grid container className={props.oemDataTab === "CSI" ? "m-0 px-[10px]" : "m-0 px-[10px] py-[20px]"}>
				{props?.navigateButton("left")}
				{props?.navigateButton("right")}
				<Grid container style={props?.isPaginationPage ? { marginTop: "-150px" } : {}}>
					<OemDataSections
						content={JSON.parse(props?.data?.content)}
						parentsProps={parentsProps}
						onUpdateCellTableValue={props?.onUpdateCellTableValue}
						filterRankingDataPage={props.filterRankingDataPage}
						tableProps={props?.tableProps}
						oemDataTab={props.oemDataTab}
					/>
				</Grid>
			</Grid>
		</Grid>
	);
}
